import axios from "axios";
import moment from "moment";

export default {
    namespaced: true,
    state: {
        cart: {
            products: [],
            order_time: null,
            business: null,
            coupon: null,
            order_type: "",
            card: null,
            tips: null,
            giftCards: null,
            comment: "",
            tax: null,
            updateDate: null,
            guestGiftCardList: null,
            googleApplePayData: null,
            googleApplePayMethod: null
        },
        confirmationValues: null,
        tempAddress: null,
        tempUser: null,
        addTime: null,
        homeOffer: null
    },
    mutations: {
        setTempUser(state, val) {
            state.tempUser = val;
        },
        setTempOffer(state, val) {
            state.homeOffer = val;
        },
        setOrderTime(state, val) {
            state.cart.order_time = val;
        },
        setBusiness(state, val) {
            state.cart.business = val;
        },
        addToCart(state, val) {
            state.cart.products.push(val);
        },
        updateCart(state, val) {
            state.cart.products.splice(val.index, 1, val.item)
        },
        removeFromCart(state, index) {
            state.cart.products.splice(index, 1);
        },
        setAddTime(state, val) {
            state.cart.addTime = val;
        },
        setGiftCards(state, val) {
            state.cart.giftCards = val;
        },
        setCard(state, val) {
            state.cart.card = val;
        },
        setGoogleApplePay(state, val) {
            state.cart.googleApplePayData = val;
        },
        setGoogleApplePayMethod(state, val) {
            state.cart.googleApplePayMethod = val;
        },
        updateCartDate(state, val) {
            state.cart.updateDate = new Date();
        },
        resetCart(state) {
            state.cart.products = [];
            state.cart.order_time = null;
            state.cart.order_type = null;
            state.cart.business = null;
            state.cart.coupon = null;
            state.cart.tips = null;
            state.cart.tax = null;
            state.cart.giftCards = null;
            state.cart.card = null;
            state.cart.comment = "";
            state.cart.guestGiftCardList = null;
        },
        initCart(state) {
            state.cart.subTotal = subTotal.bind(state.cart);
            state.cart.calcOrderTime = calcOrderTime.bind(state.cart);
            state.cart.calcTax = calcTax.bind(state.cart);
            state.cart.total = total.bind(state.cart);
            state.cart.discountTotal = discountTotal.bind(state.cart);
            state.cart.calcTotalCartQuantity = calcTotalCartQuantity.bind(state.cart);
            state.cart.generateCartData = generateCartData.bind(state.cart);
        },
        setConfirmationValues(state, val) {
            state.confirmationValues = val;
        },
        setGiftCardsList(state, val) {
            state.cart.guestGiftCardList = val;
        }
    },
    actions: {
        getCreditCardList(store, {callback}) {
            let url = "";
            const gateway_id = store.rootState.shared.gatewayInfo.gateway_id;
            const user_id = store.rootState.user.user?.member_id;
            const guest_id = store.rootState.shared.guest_id;
            if (user_id && gateway_id) {
                url = `auth/gateways/${gateway_id}/users/${user_id}/credit_cards`;
            } else if (guest_id && gateway_id) {
                url = `unauth/gateways/${gateway_id}/guests/${guest_id}/credit_cards`
            } else {
                callback?.([]);
                return false
            }

            axios.get(url).then(res => {
                let cards = res.data;
                //console.log(cards);
                //console.log(res);
                callback?.(cards);
            })
        },
        deleteCreditCard(store, {id, callback,}) {
            const gateway_id = store.rootState.shared.gatewayInfo.gateway_id;
            const user_id = store.rootState.user.user?.member_id;
            axios.delete(`/auth/gateways/${gateway_id}/users/${user_id}/credit_cards/${id}`).then(res => {
                if (res.status == 200) {
                    callback?.();
                    store.commit("shared/setAlert", "Card has been removed", {root: true});
                }
            })
        },
        getGiftCards(store, {callback}) {
            const user_id = store.rootState.user.user.member_id;
            axios.get(`/auth/users/${user_id}/gift_cards`).then(res => {
                if (callback) {
                    callback(res.data);
                }
            })
        },
        getGiftCardHistory(store, {id, callback}) {
            const user_id = store.rootState.user.user.member_id;
            axios.get(`/auth/users/${user_id}/gift_cards/${id}/history`).then(res => {
                if (callback) {
                    callback(res.data);
                }
            })
        },
        getUserLoyaltyProfile(store, {callback}) {
            const user_id = store.rootState.user.user?.member_id;
            axios.get(`/auth/users/${user_id}/loyalty/profile`).then(res => {
                if (callback) {
                    callback(res);
                }
            })
        },
        getUserLoyaltyHistory(store, {callback}) {
            const user_id = store.rootState.user.user?.member_id;
            axios.get(`/auth/users/${user_id}/loyalty/history`).then(res => {
                if (callback) {
                    callback(res);
                }
            })
        },
        setCoupon({state, commit}, val) {
            if (!val) {
                return false;
            }
            if (!state.cart.coupon) {
                state.cart.coupon = [];
            }


            const foundIndex = state.cart.coupon.findIndex(c => c.offer_id === val.offer.offer_id);
            if (foundIndex !== -1) {
                state.cart.coupon.splice(foundIndex, 1);
            } else {
                let pointInCart = 0;
                state.cart.coupon.map(v => {
                    pointInCart += v.purchase_amount;
                });
                if ((pointInCart + val.offer.purchase_amount) > val.points) {
                    commit("shared/setAlert", "<h5>You do not have enough points to use this offer</h5>", {root: true});
                    return false;
                }
                if (state.cart.coupon.length === 3) {
                    commit("shared/setAlert", "<h5>You can apply maximum 3 offer</h5>", {root: true});
                    return false;
                }
                let sumDiscount = 0;

                if (val.offer.discount_type === "Percent") {
                    sumDiscount += parseFloat((val.offer.discount_value / 100) * state.cart.total())
                } else {
                    sumDiscount += parseFloat(val.offer.discount_value);
                }

                if (parseFloat(val.offer.min_amount) > parseFloat(state.cart.total())) {
                    commit("shared/setAlert", `<h4>You can't use current offer. Min amount for it $${val.offer.min_amount}</h4>`, {root: true});
                    return false;
                }

                let dislTotal = parseFloat(sumDiscount).toFixed(2);
                if (state.cart.discountTotal()) {
                    dislTotal = state.cart.discountTotal() + parseFloat(sumDiscount).toFixed(2);
                }
                if (parseFloat(state.cart.total()) < parseFloat(dislTotal)) {

                    if (parseFloat(state.cart.discountTotal()) > 0) {
                        commit("shared/setAlert", `<h4>You can't use this combination of selected offers. The discount is more than the total amount of the order.</h4>`, {root: true});
                    } else {
                        commit("shared/setAlert", `<h4>You can't use current offer. The discount is more than the total amount of the order.</h4>`, {root: true});
                    }
                    return false;
                }

                state.cart.coupon.push(val.offer);
            }
        },
        proceedOrder(store, {url, data, callback}) {
            axios.post(url, data).then(res => {
                if (res.status == 200 && res.data.success !== false) {
                    if (callback) {
                        callback(res.data);
                    }
                } else {
                    store.commit("shared/setAlert", `<h5>${res.data.error}</h5>`, {root: true});
                }
            }).catch(error => {
                if (error.response) {
                    store.commit("shared/setAlert", `<h5>${error.response.data.errors[0]}</h5>`, {root: true})
                } else {
                    store.commit("shared/setAlert", `<h5>Error. Please check your internet connection.</h5>`, {root: true})
                }
            });
        },
        loadTax(store, {callback}) {
            const member_id = store.rootState.user.user?.member_id;
            let $url = `/auth/users/${member_id}/purchases/check_prices`;
            if (!member_id) {
                $url = `unauth/guests/purchases/prices/check`;
            }
            let data = store.state.cart.generateCartData();
            delete data.user_payment.tax;
            axios.post($url, data).then(
                    res => {
                        console.log(res);
                        if (res.status == 200 && res.data.success !== false) {
                            if (!member_id) {
                                store.state.cart.tax = parseFloat(res.data?.totals?.tax).toFixed(2);
                            } else {
                                store.state.cart.tax = parseFloat(res.data?.tax).toFixed(2);
                            }
                            callback?.();
                        }
                    }
            )
        }
    }
}

//#########################################################
//Helpers

const subTotal = function () {
    let total = 0;
    this.products.map(el => {
        total += parseFloat(el.totalPrice())
    });
    return total.toFixed(2);
};

const calcTax = function () {
    let taxVal = 0;
    if (this.business.takeout_tax_percent) {
        taxVal = this.business.takeout_tax_percent;
    }

    const taxTotal = (this.subTotal() - this.discountTotal()) * (taxVal / 100);
    return taxTotal < 0 ? 0 : parseFloat(taxTotal).toFixed(2)
};

const discountTotal = function () {
    const total = this.subTotal();
    let sumDiscount = 0;
    if (this.coupon) {
        this.coupon.map(coupon => {
            if (coupon.discount_type === "Percent") {
                sumDiscount += parseFloat((coupon.discount_value / 100) * total)
            } else {
                sumDiscount += parseFloat(coupon.discount_value);
            }
        });
    }
    return sumDiscount ? sumDiscount.toFixed(2) : null;
}


const total = function () {
    const tips = (this.tips === null) ? 0 : this.tips;
    let total = (parseFloat(this.tax ? this.tax : 0) + parseFloat(this.subTotal()));
    if (this.coupon) {
        total -= this.discountTotal();
    }
    if (total < 0) {
        total = 0;
    }
    total += parseFloat(tips);
    return total.toFixed(2);
};

function calcTotalCartQuantity() {
    let total = 0;
    this.products.map(el => {
        total += el.quantity
    });
    return total;
}

function calcOrderTime(isInstance) { // if isInstance true return true or false
    let extraMins = 1
    const subTotal = this.subTotal();
    if (subTotal > 100){
        extraMins = 31
    }else if(subTotal >= 50){
        extraMins = 21
    }
    const allowedTime = moment().add(parseInt(this.addTime) + extraMins, "minutes");
    if (moment(this.order_time, "MM/DD/YY hh:mmA").isBefore(allowedTime)) {
        return isInstance ? true : allowedTime.format("MM/DD/YY hh:mmA")
    } else {
        return isInstance ? false : this.order_time;
    }
}


function generateCartData(user_info = {}) {

    user_info.business_id = parseInt(this.business.business_id)

    let items = [];
    this.products.map(el => {
        let item = {
            item_id: parseInt(el.menu_id),
            price: el.menu_price,
            title: el.menu_title,
            menu_title: el.menu_title,
            count: el.quantity,
            comment: "",
            addons: []
        };
        let addons = {}
        Object.keys(el.activeModifiers).map(m => {
            if (!addons[el.activeModifiers[m].addon_id]) {
                addons[el.activeModifiers[m].addon_id] = []
            }
            el.activeModifiers[m].checked = 1;
            el.activeModifiers[m].quantity = el.activeModifiers[m].quantity || 1;
            el.activeModifiers[m].value = el.activeModifiers[m].quantity || 1;
            addons[el.activeModifiers[m].addon_id].push(el.activeModifiers[m]);
        });

        Object.keys(addons).map(el => {
            item.addons.push({
                id: el,
                title: addons[el][0].addon_title,
                options: addons[el],
            })
        })
        items.push(item);
    });
    //#####################################################
    const order_time = this.calcOrderTime();
    let user_payment = {
        "delivery": 0,
        "method": "credit_card", // cash | credit_card
        "credit_card_id": this.card ? this.card.credit_card_id : null, // this key is present only if method = credit_card
        "tip": 0,
        "delivery_price": 0,
        "order_datetime_utc": moment(order_time, "MM/DD/YY hh:mmA").utc().format('YYYY-MM-DD HH:mm:ss'),
        "order_datetime": moment(order_time, "MM/DD/YY hh:mmA").format('YYYY-MM-DD HH:mm:ss'),
        "instant": this.calcOrderTime(true),
        "tax": this.tax,
        "delivery_address_id": 0,
        "offers": null,
        "comment": this.comment,
        "gift_cards": this.giftCards?.ids ? this.giftCards.ids : this.giftCards
    }
    if (this.googleApplePayData) {
        user_payment.method = this.googleApplePayMethod;
        user_payment.opaque_data_value = this.googleApplePayData;
    }
    if (!user_info?.member_id) {
        let tempGifts = [];
        //console.log(this.giftCards);
        this.giftCards?.ids?.map((el, index) => {
            tempGifts.push({"cvv": this.giftCards.cvv[index], "number": el})
        });
        user_payment.gift_cards = tempGifts;
    }

    //#####################################################
    let user_address = null;
    //#####################################################

    if (this.coupon) {
        user_payment.offers = [];
        this.coupon.map(c => {
            user_payment.offers.push(c.offer_id)
        });
    }

    /*if (!user_info?.member_id){
        user_payment.offers = null;
        user_payment.gift_cards = null;
    }*/

    let data = {
        user_info,
        business_id: +this.business.business_id,
        user_payment,
        items,
        user_address,
    }

    return data;
}
